(function () {

  window.announcementBarIntervals = window.announcementBarIntervals || [];

  function clearExistingIntervals() {
    // Safety check: ensure intervals array exists before trying to clear it
    if (Array.isArray(window.announcementBarIntervals)) {
      window.announcementBarIntervals.forEach(clearInterval);
    }
    window.announcementBarIntervals = [];
  }

  /*==========================================
    LIVE COUNTDOWN TICKER
  ==========================================*/
  function initCountdowns() {
    const countdowns = document.querySelectorAll(".announcement-countdown");

    countdowns.forEach((el) => {
      const dateStr = el.getAttribute("data-date");
      const daysText = el.getAttribute("data-text-days") || "days";
      const resetDays = parseInt(el.getAttribute("data-reset")) || 0;

      if (!dateStr) return;

      const targetDate = new Date(dateStr.replace(/\//g, "-"));

      function updateTimer() {
        const now = new Date();
        let difference = targetDate.getTime() - now.getTime();

        if (difference < 0 && resetDays > 0) {
          const oneDay = 24 * 60 * 60 * 1000;
          const intervalMs = resetDays * oneDay;
          const timeSinceTarget = now.getTime() - targetDate.getTime();
          const intervalsPassed = Math.floor(timeSinceTarget / intervalMs);
          const nextTargetTime = targetDate.getTime() + (intervalsPassed + 1) * intervalMs;
          difference = nextTargetTime - now.getTime();
        }

        if (difference < 0) {
          el.textContent = `00d 00h 00m 00s`;
          return;
        }

        const secs  = Math.floor((difference / 1000) % 60);
        const mins  = Math.floor((difference / 1000 / 60) % 60);
        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const days  = Math.floor(difference / (1000 * 60 * 60 * 24));

        const fDays  = String(days).padStart(2, '0');
        const fHours = String(hours).padStart(2, '0');
        const fMins  = String(mins).padStart(2, '0');
        const fSecs  = String(secs).padStart(2, '0');

        el.textContent = `${fDays}${daysText} ${fHours}:${fMins}:${fSecs}`;
      }

      updateTimer();
      const tickerInterval = setInterval(updateTimer, 1000);
      window.announcementBarIntervals.push(tickerInterval);
    });
  }

  /*==========================================
    STICKY HEADER & SPACING CONTROL
  ==========================================*/
  function updateHeader() {
    const header = document.getElementById("CustomHeader");
    if (!header) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const hasAnnouncement = document.querySelector(".announcement-bar");

    // Dynamically manage body class
    if (hasAnnouncement) {
      document.body.classList.add("has-announcement-bar");
    } else {
      document.body.classList.remove("has-announcement-bar");
    }

    if (scrollTop > 20) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }
  }

  /*==========================================
    MOBILE MENU FUNCTIONS
  ==========================================*/
  function initMobileMenu() {
    const menuToggle = document.querySelector(".mobile-menu-toggle");
    const mobileMenu = document.querySelector(".mobile-menu");
    const overlay = document.querySelector(".mobile-menu-overlay");
    const closeButton = document.querySelector(".mobile-menu-close");

    if (!mobileMenu || !overlay) return;

    function openMenu() {
      mobileMenu.classList.add("active");
      overlay.classList.add("active");
      document.body.style.overflow = "hidden";
      menuToggle?.setAttribute("aria-expanded", "true");
    }

    function closeMenu() {
      mobileMenu.classList.remove("active");
      overlay.classList.remove("active");
      document.body.style.overflow = "";
      menuToggle?.setAttribute("aria-expanded", "false");
      resetAccordion();
    }

    if (menuToggle) {
      menuToggle.addEventListener("click", function (event) {
        event.preventDefault();
        openMenu();
      });
    }

    if (closeButton) {
      closeButton.addEventListener("click", function (event) {
        event.preventDefault();
        closeMenu();
      });
    }

    if (overlay) {
      overlay.addEventListener("click", function () {
        closeMenu();
      });
    }

    const onKeyDown = function (event) {
      if (event.key === "Escape") {
        closeMenu();
      }
    };
    document.removeEventListener("keydown", window.customHeaderEscListener);
    window.customHeaderEscListener = onKeyDown;
    document.addEventListener("keydown", onKeyDown);

    const onResize = function () {
      if (window.innerWidth > 990) {
        closeMenu();
      }
    };
    window.removeEventListener("resize", window.customHeaderResizeListener);
    window.customHeaderResizeListener = onResize;
    window.addEventListener("resize", onResize);

    const mobileLinks = document.querySelectorAll(".mobile-navigation a");
    mobileLinks.forEach(function (link) {
      link.addEventListener("click", function () {
        closeMenu();
      });
    });
  }

  /*==========================================
    MOBILE ACCORDIONS
  ==========================================*/
  function initAccordions() {
    const dropdownButtons = document.querySelectorAll(".dropdown-btn");

    dropdownButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        const parent = this.parentElement;
        const isOpen = parent.classList.contains("active");

        if (!parent.classList.contains("mobile-sub-dropdown")) {
          const siblings = parent.parentElement.children;
          [...siblings].forEach(function (item) {
            if (item !== parent) {
              item.classList.remove("active");
              const siblingButton = item.querySelector(".dropdown-btn");
              if (siblingButton) {
                siblingButton.setAttribute("aria-expanded", "false");
              }
            }
          });
        }

        parent.classList.toggle("active");
        this.setAttribute("aria-expanded", !isOpen);
      });
    });

    const subDropdownButtons = document.querySelectorAll(".mobile-sub-dropdown > .dropdown-btn");
    subDropdownButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        const parent = this.parentElement;
        const isOpen = parent.classList.contains("active");

        parent.classList.toggle("active");
        this.setAttribute("aria-expanded", !isOpen);
      });
    });
  }

  function resetAccordion() {
    document.querySelectorAll(".mobile-dropdown, .mobile-sub-dropdown").forEach(function (item) {
      item.classList.remove("active");
    });

    document.querySelectorAll(".dropdown-btn").forEach(function (button) {
      button.setAttribute("aria-expanded", "false");
    });
  }

  /*==========================================
    WISHLIST BADGE (SWYM)
  ==========================================*/
  function updateWishlistCount() {
    const wishlistBadge = document.querySelector(".wishlist-count");
    if (!wishlistBadge) return;

    const swymBadge = document.querySelector(".swym-anchor-badge");
    if (!swymBadge) {
      wishlistBadge.classList.remove("show");
      wishlistBadge.textContent = "";
      return;
    }

    const count = parseInt(swymBadge.textContent.trim()) || 0;
    wishlistBadge.textContent = count;
    wishlistBadge.classList.toggle("show", count > 0);
  }

  /*==========================================
    CART BADGE
  ==========================================*/
  async function updateCartCount() {
    const cartBadge = document.getElementById("custom-cart-count");
    if (!cartBadge) return;

    try {
      const response = await fetch("/cart.js");
      if (!response.ok) return;
      const cart = await response.json();
      cartBadge.textContent = cart.item_count;
      cartBadge.classList.toggle("show", cart.item_count > 0);
    } catch (error) {
      console.error("Cart Count Error", error);
    }
  }

  /*==========================================
    WISHLIST CLICK
  ==========================================*/
  function initWishlistClick() {
    const wishlistButton = document.querySelector(".custom-wishlist-icon, .wishlist-icon, .wishlist-link");
    if (wishlistButton) {
      wishlistButton.addEventListener("click", function (e) {
        // 1. Fallback to Swym's anchor first (the method that worked perfectly before combining)
        const swymButton = document.querySelector("#swym-anchor a");
        if (swymButton) {
          e.preventDefault();
          swymButton.click();
          return;
        }

        // 2. Try the Swym Javascript API second
        if (window._swat && typeof window._swat.openWishlist === "function") {
          e.preventDefault();
          window._swat.openWishlist();
          return;
        }
      });
    }
  }

  /*==========================================
    GLOBAL INITIALIZER (FAIL-SAFE)
  ==========================================*/
  function initCustomHeader() {
    const tasks = [
      { name: "updateHeader", fn: updateHeader },
      { name: "clearExistingIntervals", fn: clearExistingIntervals },
      { name: "initCountdowns", fn: initCountdowns },
      { name: "initMobileMenu", fn: initMobileMenu },
      { name: "initAccordions", fn: initAccordions },
      { name: "initWishlistClick", fn: initWishlistClick },
      { name: "updateWishlistCount", fn: updateWishlistCount },
      { name: "updateCartCount", fn: updateCartCount }
    ];

    // Safely run each task: a failure in one won't crash the others
    tasks.forEach(task => {
      try {
        task.fn();
      } catch (e) {
        console.warn(`Error initializing custom header task [${task.name}]:`, e);
      }
    });
  }

  // Page Load Initialization
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCustomHeader);
  } else {
    initCustomHeader();
  }

  if (!window.customHeaderScrollRegistered) {
    window.addEventListener("scroll", updateHeader, { passive: true });
    window.customHeaderScrollRegistered = true;
  }

  if (!window.customHeaderGlobalEventsRegistered) {
    document.addEventListener("custom:cart-updated", updateCartCount);
    
    window.addEventListener("pageshow", function () {
      updateWishlistCount();
      updateCartCount();
    });

    document.addEventListener("swym:collections-loaded", updateWishlistCount);
    document.addEventListener("swym:updated", updateWishlistCount);
    document.addEventListener("cart:refresh", updateCartCount);
    document.addEventListener("cart:updated", updateCartCount);
    document.addEventListener("product:added", updateCartCount);

    window.addEventListener("focus", function () {
      updateWishlistCount();
      updateCartCount();
    });

    window.customHeaderGlobalEventsRegistered = true;
  }

  /*==========================================
    SHOPIFY THEME EDITOR EVENTS
  ==========================================*/
  document.addEventListener("shopify:section:load", function (e) {
    if (e.target.classList.contains("section-custom-header") || e.target.querySelector(".custom-header-wrapper")) {
      initCustomHeader();
    }
  });

  document.addEventListener("shopify:section:select", function (e) {
    if (e.target.classList.contains("section-custom-header") || e.target.querySelector(".custom-header-wrapper")) {
      initCustomHeader();
    }
  });

  document.addEventListener("shopify:section:unload", function (e) {
    if (e.target.classList.contains("section-custom-header") || e.target.querySelector(".custom-header-wrapper")) {
      clearExistingIntervals();
    }
  });

})();